import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import * as React from 'react';
import { alpha, styled } from '@mui/material';
import Box from '@mui/material/Box';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import ContactSupportIcon from '@mui/icons-material/ContactSupport';

interface ListeFaq {
  _id: string;
  question: string;
  answer: string;
}

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ flexGrow: 1 }}>{children}</Box>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const AntTab = styled(Tab)(({ theme }) => ({
  marginRight: theme.spacing(1),
  textTransform: 'none',
  '&.Mui-selected': {
    color: theme.palette.primary.main,
    background: alpha(theme.palette.primary.main, 0.1),
    borderBottom: 'none',
  },
}));

const Item = styled(Paper)(({ theme }) => ({
  '&:hover': {
    boxShadow: '0 15px 25px 0 rgba(0,0,0,0.1)',
    background: 'rgba(255, 255, 255, 0.1)',
  },
}));

interface ITechList {
  title: string;
  technologies: ITechnology[];
}

const FAQ: React.FC<{
  data: { tabs: { _id: string; name: string; faq: ListeFaq[] }[] };
}> = ({ data }) => {
  console.log('🚀 ~ file: FAQ.tsx ~ line 80 ~ data', data);
  const [expanded, setExpanded] = React.useState<string | false>('panel0');
  const [value, setValue] = React.useState(0);

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  const handleChange =
    (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
      setExpanded(isExpanded ? panel : false);
    };

  return (
    <Container sx={{ position: 'relative', py: 6 }}>
      <Stack
        direction={{ xs: 'column', md: 'row' }}
        justifyContent="space-between"
        spacing={2}
      >
        <Box
          sx={{
            width: '100%',
          }}
        >
          <Tabs
            value={value}
            onChange={handleTabChange}
            variant="scrollable"
            scrollButtons="auto"
            allowScrollButtonsMobile
            aria-label="FAQ"
          >
            {data?.tabs?.map((el, i) => (
              <AntTab key={el._id} label={el.name} {...a11yProps(i)} />
            ))}
          </Tabs>
        </Box>
      </Stack>
      {data?.tabs?.map((el, i) => (
        <TabPanel key={el._id} value={value} index={i}>
          <Stack sx={{ py: 4 }}>
            {el.faq?.map((el, i) => (
              <Accordion
                expanded={expanded === `panel${i}`}
                onChange={handleChange(`panel${i}`)}
                TransitionProps={{ unmountOnExit: true }}
                elevation={0}
                key={i}
                sx={{
                  py: 1.5,
                }}
              >
                <AccordionSummary
                  expandIcon={
                    expanded === `panel${i}` ? (
                      <RemoveIcon color="primary" />
                    ) : (
                      <AddIcon color="primary" />
                    )
                  }
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
                  <Stack direction="row" spacing={1} alignItems="center">
                    <ContactSupportIcon color="primary" />
                    <Typography variant="h6" fontWeight={700}>
                      {el?.question}
                    </Typography>
                  </Stack>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography
                    color="text.secondary"
                    component="div"
                    dangerouslySetInnerHTML={{ __html: el?.answer }}
                  ></Typography>
                </AccordionDetails>
              </Accordion>
            ))}
          </Stack>
        </TabPanel>
      ))}
    </Container>
  );
};

export default FAQ;
